import type { UpdateCourseDraft200LocalizedBasicInfo } from './updateCourseDraft200LocalizedBasicInfo';
import type { UpdateCourseDraft200LocalizedSections } from './updateCourseDraft200LocalizedSections';
import type { UpdateCourseDraft200Price } from './updateCourseDraft200Price';
import type { UpdateCourseDraft200SectionsItem } from './updateCourseDraft200SectionsItem';

/**
 * 코스 초안 상세 정보
 */
export type UpdateCourseDraft200 = {
  /**
   * 기본 정보 편집 시 활성화된 언어 코드
   * @nullable
   */
  activeBasicInfoLanguage?: string | null;
  /**
   * 현재 활성화된 편집 언어 코드
   * @nullable
   */
  activeLanguage?: string | null;
  /**
   * 댓글 허용 여부
   * @nullable
   */
  allowComments?: boolean | null;
  /** 생성 시간 */
  createdAt: string;
  /**
   * 기본 언어 코드
   * @nullable
   */
  defaultLanguage?: string | null;
  /**
   * 코스 설명
   * @nullable
   */
  description?: string | null;
  /** 코스 초안 ID */
  id: string;
  /** 강사 ID */
  instructorId: string;
  /** 강사 이름 */
  instructorName: string;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /**
   * 코스 난이도 (자유 텍스트 입력)
   * @minLength 1
   * @maxLength 50
   * @nullable
   */
  level?: string | null;
  /**
   * 언어별 기본 정보 매핑
   * @nullable
   */
  localizedBasicInfo?: UpdateCourseDraft200LocalizedBasicInfo;
  /**
   * 언어별 섹션 정보 매핑
   * @nullable
   */
  localizedSections?: UpdateCourseDraft200LocalizedSections;
  /**
   * 코스 가격 정보
   * @nullable
   */
  price?: UpdateCourseDraft200Price;
  /**
   * 코스 섹션 목록
   * @nullable
   */
  sections?: UpdateCourseDraft200SectionsItem[] | null;
  /**
   * 지원 언어 목록
   * @nullable
   */
  supportedLanguages?: string[] | null;
  /**
   * 썸네일 이미지 URL
   * @nullable
   */
  thumbnailUrl?: string | null;
  /** 코스 제목 */
  title: string;
  /** 최종 수정 시간 */
  updatedAt: string;
};
